import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";

// Multilanguges Components
import { IntlProvider } from "react-intl";

//componets
import HomePage from '../Pages/HomePage';

class Index extends Component {
    state = {  }
 
    render() { 
        return ( 
            <IntlProvider>
                <Router>
                    <Route exact path="/" component={HomePage} />
                </Router>
            </IntlProvider>
          );
    }
}
 
export default Index;